export default __webpack_public_path__ + "static/transforming_mobility_2021_recap-b0db8a859bda8393892b10b5fe0c404d.png";